import React from "react";
import { BackProfileButton } from "./style";
import { BiArrowBack } from "react-icons/bi";

interface BackProfileButtonCompProps {
  title: string;
  closeFunction: () => void;
}

export default function BackProfileButtonComp({
  title,
  closeFunction,
}: BackProfileButtonCompProps) {
  return (
    <BackProfileButton>
      <button onClick={closeFunction}>
        <BiArrowBack />
      </button>
      <span>{title}</span>
    </BackProfileButton>
  );
}
